import { render, staticRenderFns } from "./tempoVoo.vue?vue&type=template&id=0fac3628"
import script from "./tempoVoo.vue?vue&type=script&lang=js"
export * from "./tempoVoo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports